module.exports = __webpack_public_path__ + "schniewindt.ae1630eb34c38f0039911f40a343cee7.jpg";